// S3 url
export const BASE_S3_URL = `${process.env.REACT_APP_BASE_S3_URL}`;

// labeling url
const hostname = window && window.location && window.location.hostname;
export const BASE_LABELING_URL =
  hostname.indexOf("localhost") < 0 ? process.env.REACT_APP_BASE_LABELING_URL : "http://localhost:8080/";
